import { render } from "./discount-campaigns.vue?vue&type=template&id=68f8c07b"
import script from "./discount-campaigns.vue?vue&type=script&lang=js"
export * from "./discount-campaigns.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__